import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const KEY = "sapore-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("sapore:cookie-prefs", reopen);
    return () => window.removeEventListener("sapore:cookie-prefs", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <motion.div
      initial={{ y: 120, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:left-6 md:max-w-md z-[55]"
      data-testid="cookie-banner"
    >
      <div className="bg-sand border border-charred/15 rounded-lg p-5 shadow-xl">
        <p className="text-sm text-charred leading-relaxed">
          Questo sito utilizza soltanto cookie tecnici, necessari al funzionamento e a ricordare la tua scelta. Non sono attivi strumenti di misurazione o profilazione: se verranno aggiunti in futuro, saranno attivati solo dopo il tuo consenso.
        </p>
        <div className="mt-4 flex gap-3">
          <button
            onClick={() => choose("accepted")}
            data-testid="cookie-accept-btn"
            className="rounded-full bg-terracotta text-cream px-5 py-2 text-sm font-semibold hover:bg-terracotta-dark transition-colors"
          >
            Accetta
          </button>
          <button
            onClick={() => choose("rejected")}
            data-testid="cookie-reject-btn"
            className="rounded-full border border-charred/30 text-charred px-5 py-2 text-sm font-semibold hover:bg-charred hover:text-cream transition-colors"
          >
            Rifiuta
          </button>
        </div>
      </div>
    </motion.div>
  );
}
